/**
 * 探索分析页面
 */

export default {
  dbl_exploration_title: "Exploration Analysis",
  dbl_exploration_leave_info: "Leave the current analysis task?",
  dbl_exploration_metric: "METRICS",
  dbl_exploration_filter: "FILTERS",
  dbl_exploration_dimension: "DIMENSIONS",
  dbl_exploration_add_metric: "Add METRICS",
  dbl_exploration_add_filter: "Add FILTERS",
  dbl_exploration_add_dimension: "Add DIMENSIONS",
  dbl_exploration_edit_metric_name: "Modify Indicator Name",
  dbl_exploration_and_relation: "Add AND Relationship",
  dbl_exploration_and: "AND",
  dbl_exploration_or: "OR",
  dbl_exploration_field_name: "Field name: ",
  dbl_exploration_data_table: "Data source table: ",
  dbl_exploration_selected: "Selected and cannot be selected again",
  dbl_exploration_custom_region_bubble1: "The value cannot be empty",
  dbl_exploration_custom_region_bubble2: "The left value cannot be greater than the right value",
  dbl_exploration_tab_all: "All Dimensions",
  dbl_exploration_tab_frequent: "Recommendations",
  dbl_exploration_tab_package: "User Package",
  dbl_exploration_tab_favorite: "My Favorite",
  dbl_exploration_all: "All",
  dbl_exploration_common: "Common",
  dbl_exploration_register: "Register",
  dbl_exploration_active: "Active",
  dbl_exploration_pay: "Pay",
  dbl_exploration_exist: "Retention",
  dbl_exploration_gone: "Churn",
  dbl_exploration_of: "of",
  dbl_exploration_by: "by",
  dbl_exploration_discrete: "Discrete Value",
  dbl_exploration_custom_region: "Custom Region",
  dbl_exploration_region: "Region",
  dbl_exploration_calculate_hint: "The calculation conditions have been modified. Please click the Calculate button again to complete the analysis",
  dbl_exploration_clear_message: 'Are you sure to clear all options?',
  dbl_exploration_clear_des: 'Analysis settings and data logic that were not previously saved will be lost.',
  dbl_exploration_save_success: "Save {name} success",
  dbl_exploration_save_as_success: "Save as {name} success",
  dbl_exploration_finish_calculate: "Termination calculation",
  dbl_exploration_not_empty_metric: "Statistical metrics cannot be empty",
  dbl_exploration_calculate: "Calculate",
  dbl_exploration_calculate_by_dimension: "calculate by dimension",
  dbl_exploration_: "",
  dbl_exploration_: "",
  dbl_exploration_: "",

};